import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export interface StudentSession {
  studentId: string;
  name: string;
  email: string;
  mentorId: string;
  course: string;
  // For My Tasks (server/routes/tasks.js); sessions saved before it have none
  // and sign in again to see their tasks
  studentToken?: string;
}

interface StudentContextType {
  session: StudentSession | null;
  setSession: (s: StudentSession | null) => void;
  signOut: () => void;
}

const StudentContext = createContext<StudentContextType>({
  session: null,
  setSession: () => {},
  signOut: () => {},
});

const SESSION_KEY = 'vt_student_session';

export function StudentProvider({ children }: { children: ReactNode }) {
  const [session, setSessionState] = useState<StudentSession | null>(() => {
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });

  const setSession = (s: StudentSession | null) => {
    setSessionState(s);
    if (s) localStorage.setItem(SESSION_KEY, JSON.stringify(s));
    else localStorage.removeItem(SESSION_KEY);
  };

  const signOut = () => setSession(null);

  return (
    <StudentContext.Provider value={{ session, setSession, signOut }}>
      {children}
    </StudentContext.Provider>
  );
}

export function useStudentSession() {
  return useContext(StudentContext);
}
